import { notification } from "antd";
import { showLoading, hideLoading } from "react-redux-loading-bar";
import { ENVIRONMENT } from "@mds/common/constants/environment";
import { error, request, success } from "../actions/genericActions";
import * as API from "@mds/common/constants/API";
import { createRequestHeader } from "../utils/RequestHeaders";
import CustomAxios from "../customAxios";
import * as noticeOfWorkActions from "../actions/noticeOfWorkActions";
import { NetworkReducerTypes } from "@mds/common/constants/networkReducerTypes";

// vFCBC & NROS NoW initial submissions
export const fetchNoticeOfWorkApplication = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplication(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchImportNoticeOfWorkSubmissionDocumentsJob = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_IMPORT_NOTICE_OF_WORK_SUBMISSION_DOCUMENTS_JOB));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.docManUrl}${API.IMPORT_NOTICE_OF_WORK_SUBMISSION_DOCUMENTS_JOB(
        applicationGuid
      )}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_IMPORT_NOTICE_OF_WORK_SUBMISSION_DOCUMENTS_JOB));
      dispatch(noticeOfWorkActions.storeImportNoticeOfWorkSubmissionDocumentsJob(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_IMPORT_NOTICE_OF_WORK_SUBMISSION_DOCUMENTS_JOB)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchNoticeOfWorkApplications = (params = {}) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATIONS));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_LIST(params)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATIONS));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplications(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATIONS)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchMineNoticeOfWorkApplications = (params = {}) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_MINE_NOTICE_OF_WORK_APPLICATIONS));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_LIST(params)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_MINE_NOTICE_OF_WORK_APPLICATIONS));
      dispatch(noticeOfWorkActions.storeMineNoticeOfWorkApplications(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_MINE_NOTICE_OF_WORK_APPLICATIONS)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchProponentNoticeOfWorkApplicationsList = (mineGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_PROPONENT_NOTICE_OF_WORK_APPLICATIONS_LIST));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.PROPONENT_NOTICE_OF_WORK_APPLICATION_LIST(mineGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_PROPONENT_NOTICE_OF_WORK_APPLICATIONS_LIST));
      dispatch(noticeOfWorkActions.storeProponentNoticeOfWorkApplicationsList(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_PROPONENT_NOTICE_OF_WORK_APPLICATIONS_LIST)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchProponentNoticeOfWorkApplication = (nowApplicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_PROPONENT_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.PROPONENT_NOTICE_OF_WORK_APPLICATION(nowApplicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_PROPONENT_NOTICE_OF_WORK_APPLICATION));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplication(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_PROPONENT_NOTICE_OF_WORK_APPLICATION)))
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkApplication = (payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_LIST()}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION));
      notification.success({
        message: "Successfully created Permit Amendment Application",
        duration: 10,
      });
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION));
    })
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkApplicationImportSubmissionDocumentsJob = (applicationGuid) => (
  dispatch
) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_IMPORT_SUBMISSION_DOCUMENTS_JOB));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_IMPORT_SUBMISSION_DOCUMENTS_JOB(applicationGuid)}`,
      {},
      createRequestHeader()
    )
    .then((response) => {
      dispatch(
        success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_IMPORT_SUBMISSION_DOCUMENTS_JOB)
      );
      notification.success({
        message: "Successfully created the Notice of Work Submission Documents Import Job",
        duration: 10,
      });
      return response;
    })
    .catch(() => {
      dispatch(
        error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_IMPORT_SUBMISSION_DOCUMENTS_JOB)
      );
    })
    .finally(() => dispatch(hideLoading()));
};

export const importNoticeOfWorkApplication = (
  applicationGuid,
  payload,
  message = "Successfully verified the Notice of Work"
) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.IMPORT_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_IMPORT(applicationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message,
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.IMPORT_NOTICE_OF_WORK_APPLICATION));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.IMPORT_NOTICE_OF_WORK_APPLICATION));
    })
    .finally(() => dispatch(hideLoading()));
};

export const fetchImportedNoticeOfWorkApplication = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_IMPORTED_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_IMPORTED_NOTICE_OF_WORK_APPLICATION));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplication(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_IMPORTED_NOTICE_OF_WORK_APPLICATION)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchOriginalNoticeOfWorkApplication = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_ORIGINAL_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION(applicationGuid)}?original=True`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_ORIGINAL_NOTICE_OF_WORK_APPLICATION));
      dispatch(noticeOfWorkActions.storeOriginalNoticeOfWorkApplication(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_ORIGINAL_NOTICE_OF_WORK_APPLICATION)))
    .finally(() => dispatch(hideLoading()));
};

export const updateNoticeOfWorkApplication = (
  payload,
  nowApplicationGuid,
  message = "Successfully updated the permit application."
) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION));
  dispatch(showLoading());
  return CustomAxios()
    .put(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION(nowApplicationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message,
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION));
    })
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkApplicationProgress = (applicationGuid, progressCode, message) => (
  dispatch
) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_PROGRESS));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_PROGRESS(
        applicationGuid,
        progressCode
      )}`,
      {},
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message,
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_PROGRESS));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_PROGRESS));
    })
    .finally(() => dispatch(hideLoading()));
};

export const updateNoticeOfWorkApplicationProgress = (
  applicationGuid,
  progressCode,
  payload,
  message
) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_PROGRESS));
  dispatch(showLoading());
  return CustomAxios()
    .put(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_PROGRESS(
        applicationGuid,
        progressCode
      )}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message,
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_PROGRESS));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_PROGRESS));
    })
    .finally(() => dispatch(hideLoading()));
};

export const fetchNoticeOfWorkApplicationReviews = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_REVIEW));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_REVIEW(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_REVIEW));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplicationReviews(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_REVIEW)))
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkApplicationReview = (applicationGuid, payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_REVIEW));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_REVIEW(applicationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully added Review",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_REVIEW));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_REVIEW));
    })
    .finally(() => dispatch(hideLoading()));
};

export const updateNoticeOfWorkApplicationReview = (
  applicationGuid,
  applicationReviewId,
  payload
) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_REVIEW));
  dispatch(showLoading());
  return CustomAxios()
    .put(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_REVIEW(
        applicationGuid
      )}/${applicationReviewId}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully updated Review",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_REVIEW));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_REVIEW));
    })
    .finally(() => dispatch(hideLoading()));
};

export const deleteNoticeOfWorkApplicationReview = (applicationGuid, applicationReviewId) => (
  dispatch
) => {
  dispatch(request(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_REVIEW));
  dispatch(showLoading());
  return CustomAxios()
    .delete(
      `${ENVIRONMENT.apiUrl +
      API.NOTICE_OF_WORK_APPLICATION_REVIEW(applicationGuid)}/${applicationReviewId}`,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully removed the review",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_REVIEW));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_REVIEW)))
    .finally(() => dispatch(hideLoading()));
};

export const editNoticeOfWorkDocument = (now_application_guid, mineDocumentGuid, payload) => (
  dispatch
) => {
  dispatch(showLoading("modal"));
  dispatch(request(NetworkReducerTypes.ADD_DOCUMENT_TO_NOTICE_OF_WORK));
  return CustomAxios()
    .put(
      `${ENVIRONMENT.apiUrl +
      API.NOTICE_OF_WORK_DOCUMENT(now_application_guid)}/${mineDocumentGuid}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.ADD_DOCUMENT_TO_NOTICE_OF_WORK));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.ADD_DOCUMENT_TO_NOTICE_OF_WORK)))
    .finally(() => dispatch(hideLoading("modal")));
};

export const sortNoticeOfWorkDocuments = (now_application_guid, payload) => (dispatch) => {
  dispatch(showLoading());
  dispatch(request(NetworkReducerTypes.SORT_NOTICE_OF_WORK_DOCUMENTS));
  return CustomAxios()
    .put(
      `${ENVIRONMENT.apiUrl}${API.SORT_NOTICE_OF_WORK_DOCUMENTS(now_application_guid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.SORT_NOTICE_OF_WORK_DOCUMENTS));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.SORT_NOTICE_OF_WORK_DOCUMENTS)))
    .finally(() => dispatch(hideLoading()));
};

export const updateNoticeOfWorkStatus = (now_application_guid, payload) => (dispatch) => {
  dispatch(showLoading("modal"));
  dispatch(request(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_STATUS));
  return CustomAxios()
    .put(
      ENVIRONMENT.apiUrl + API.NOTICE_OF_WORK_APPLICATION_STATUS(now_application_guid),
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_STATUS));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_STATUS));
    })
    .finally(() => dispatch(hideLoading("modal")));
};

export const setNoticeOfWorkApplicationDocumentDownloadState = (payload) => (dispatch) => {
  dispatch(noticeOfWorkActions.storeNoticeOfWorkApplicationDocumentDownloadState(payload));
};

export const createApplicationDelay = (applicationGuid, payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_DELAY));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_DELAY(applicationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully started a delay.",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_DELAY));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_DELAY));
    })
    .finally(() => dispatch(hideLoading()));
};

export const updateApplicationDelay = (applicationGuid, delayGuid, payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_DELAY));
  dispatch(showLoading());
  return CustomAxios()
    .put(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_DELAY(applicationGuid, delayGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully stopped the delay.",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_DELAY));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.UPDATE_NOTICE_OF_WORK_APPLICATION_DELAY));
    })
    .finally(() => dispatch(hideLoading()));
};

export const fetchApplicationDelay = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.FETCH_NOTICE_OF_WORK_APPLICATION_DELAY));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_DELAY(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.FETCH_NOTICE_OF_WORK_APPLICATION_DELAY));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplicationDelay(response.data));
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.FETCH_NOTICE_OF_WORK_APPLICATION_DELAY));
    })
    .finally(() => dispatch(hideLoading()));
};

export const deleteNoticeOfWorkApplicationDocument = (applicationGuid, mineDocumentGuid) => (
  dispatch
) => {
  dispatch(request(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_DOCUMENT));
  dispatch(showLoading());
  return CustomAxios()
    .delete(
      `${ENVIRONMENT.apiUrl + API.NOTICE_OF_WORK_DOCUMENT(applicationGuid)}/${mineDocumentGuid}`,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully removed the document",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_DOCUMENT));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_DOCUMENT)))
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkDocumentVersion = (
  applicationGuid,
  mineDocumentGuid,
  documentManagerVersionGuid
) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_DOCUMENT_VERSION));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_DOCUMENT_VERSIONS(applicationGuid, mineDocumentGuid)}`,
      { document_manager_version_guid: documentManagerVersionGuid },
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully replaced the document",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_DOCUMENT_VERSION));
      return response;
    })
    .catch((err) => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_DOCUMENT_VERSION));
      throw err;
    })
    .finally(() => dispatch(hideLoading()));
};

export const archiveNoticeOfWorkDocuments = (applicationGuid, mineDocumentGuids) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.ARCHIVE_NOTICE_OF_WORK_DOCUMENTS));
  dispatch(showLoading());
  return CustomAxios()
    .patch(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_DOCUMENTS_ARCHIVE(applicationGuid)}`,
      { mine_document_guids: mineDocumentGuids },
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: `Successfully archived ${mineDocumentGuids.length > 1 ? "the documents" : "the document"}`,
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.ARCHIVE_NOTICE_OF_WORK_DOCUMENTS));
      return response;
    })
    .catch((err) => {
      dispatch(error(NetworkReducerTypes.ARCHIVE_NOTICE_OF_WORK_DOCUMENTS));
      throw err;
    })
    .finally(() => dispatch(hideLoading()));
};

export const createAdminAmendmentApplication = (payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_ADMIN_AMENDMENT_APPLICATION));
  dispatch(showLoading("modal"));
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.ADMINISTRATIVE_AMENDMENT_APPLICATION}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.CREATE_ADMIN_AMENDMENT_APPLICATION));
      notification.success({
        message: "Successfully created an Administrative Amendment Application",
        duration: 10,
      });
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_ADMIN_AMENDMENT_APPLICATION));
    })
    .finally(() => dispatch(hideLoading("modal")));
};

export const fetchNoticeOfWorkApplicationTierHistory = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_TIER_HISTORY));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_TIER_HISTORY(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_TIER_HISTORY));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_TIER_HISTORY)))
    .finally(() => dispatch(hideLoading()));
};

export const fetchPipConsultationAreaData = () => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_PIP_CONSULTATION_AREA_DATA));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.PIP_CONSULTATION_AREA_DATA}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_PIP_CONSULTATION_AREA_DATA));
      dispatch(noticeOfWorkActions.storePipConsultationAreaData(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_PIP_CONSULTATION_AREA_DATA)))
    .finally(() => dispatch(hideLoading()));
}

export const fetchNoticeOfWorkApplicationNations = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_NATIONS));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_NATION(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_NATIONS));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkApplicationNation(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_NOTICE_OF_WORK_APPLICATION_NATIONS)))
    .finally(() => dispatch(hideLoading()));
}

export const createNoticeOfWorkApplicationNation = (applicationGuid, payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_NATION));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_NATION(applicationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_NATION));
      notification.success({
        message: "Successfully created a Notice of work application nation.",
        duration: 10,
      });

      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_NATION));
    })
    .finally(() => dispatch(hideLoading()));
};

export const deleteNoticeOfWorkApplicationNation = (applicationGuid, nationGuid) => (
  dispatch
) => {
  dispatch(request(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_NATION));
  dispatch(showLoading());
  return CustomAxios()
    .delete(
      `${ENVIRONMENT.apiUrl + API.NOTICE_OF_WORK_APPLICATION_NATION(applicationGuid, nationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      notification.success({
        message: "Successfully removed the nation.",
        duration: 10,
      });
      dispatch(success(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_NATION));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.REMOVE_NOTICE_OF_WORK_APPLICATION_NATION)))
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkApplicationNationEvent = (applicationGuid, nationGuid, payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_NATION_EVENT));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_APPLICATION_NATION_EVENT(applicationGuid, nationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_NATION_EVENT));
      notification.success({
        message: "Successfully created a Notice of work application nation event.",
        duration: 10,
      });
      return response;
    })
    .catch(() => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_APPLICATION_NATION_EVENT));
    })
    .finally(() => dispatch(hideLoading()));
};

export const fetchNoticeOfWorkReferralPackages = (applicationGuid) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.GET_NOTICE_OF_WORK_REFERRAL_PACKAGES));
  dispatch(showLoading());
  return CustomAxios()
    .get(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_REFERRAL_PACKAGES(applicationGuid)}`,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.GET_NOTICE_OF_WORK_REFERRAL_PACKAGES));
      dispatch(noticeOfWorkActions.storeNoticeOfWorkReferralPackages(response.data));
      return response;
    })
    .catch(() => dispatch(error(NetworkReducerTypes.GET_NOTICE_OF_WORK_REFERRAL_PACKAGES)))
    .finally(() => dispatch(hideLoading()));
};

export const createNoticeOfWorkReferralPackage = (applicationGuid, payload) => (dispatch) => {
  dispatch(request(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_REFERRAL_PACKAGE));
  dispatch(showLoading());
  return CustomAxios()
    .post(
      `${ENVIRONMENT.apiUrl}${API.NOTICE_OF_WORK_REFERRAL_PACKAGES(applicationGuid)}`,
      payload,
      createRequestHeader()
    )
    .then((response) => {
      dispatch(success(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_REFERRAL_PACKAGE));
      return response;
    })
    .catch((err) => {
      dispatch(error(NetworkReducerTypes.CREATE_NOTICE_OF_WORK_REFERRAL_PACKAGE));
      throw err;
    })
    .finally(() => dispatch(hideLoading()));
};